/**
 * Anti-gel Radix — repris de l'app Courses (D:\COURSES\LOVABLE), où ce hook a
 * réglé un bug réel : Radix laisse parfois `body { pointer-events: none }`
 * après fermeture d'une Dialog contenant un Select → application figée.
 * Sonde toutes les 400 ms et restaure si aucune couche modale n'est ouverte.
 * Monté UNE fois dans App.
 */
import { useEffect } from "react";

export function usePointerEventsGuard(): void {
  useEffect(() => {
    const interval = window.setInterval(() => {
      if (document.body.style.pointerEvents !== "none") return;
      const openLayer = document.querySelector(
        "[data-state='open'][role='dialog'], [data-state='open'][role='alertdialog'], [data-radix-popper-content-wrapper]",
      );
      if (!openLayer) {
        document.body.style.pointerEvents = "";
      }
    }, 400);
    return () => window.clearInterval(interval);
  }, []);
}
